
/**
 * useId 函数生成一个随机字符串，用作 ID。
 */
export const useId = () => Math.random().toString(16).slice(2)

/** 获取flv播放地址 */
export const useFlvUrl = (streamPath: string) => `/rts-api/hdl/${streamPath}.flv`
